var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4167 17.0833C4.10837 17.775 5.22503 17.775 5.9167 17.0833L16.75 6.25001C17.4417 5.55835 17.4417 4.44168 16.75 3.75001C16.0584 3.05835 14.9417 3.05835 14.25 3.75001L3.4167 14.5833C2.72503 15.275 2.72503 16.3917 3.4167 17.0833Z",
    stroke: "#CC457D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5083 7.49167L13.0083 4.99167",
    stroke: "#CC457D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 2.03332L8.83325 1.66666L8.46659 2.91666L8.83325 4.16666L7.58325 3.79999L6.33325 4.16666L6.69992 2.91666L6.33325 1.66666L7.58325 2.03332Z",
    stroke: "#CC457D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.03332L5.5 6.66666L5.13333 7.91666L5.5 9.16666L4.25 8.79999L3 9.16666L3.36667 7.91666L3 6.66666L4.25 7.03332Z",
    stroke: "#CC457D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 11.2L18 10.8333L17.6333 12.0833L18 13.3333L16.75 12.9667L15.5 13.3333L15.8667 12.0833L15.5 10.8333L16.75 11.2Z",
    stroke: "#CC457D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicpen);
export default __webpack_public_path__ + "static/media/magicpen.159ed82ffa5576056c9e6ee371b26feb.svg";
export { ForwardRef as ReactComponent };